export default "__VITE_ASSET__CWj1Thf1__"